export const Textarea = ({ name, value, dispatch }) => {
    return(
        <label className="textArea">
            <span>{name}</span>
            <textarea onChange={(e) => dispatch({ type: "change", name, value: e.target.value })} value={value} name={name}/>
        </label>
    )
}